export { default as GenericPortlet } from "./GenericPortlet";
